// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/global.css';
import './App.css';
import AppRoutes from './routes/routes';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  return (    
    <Router>
      <div className="App">
        <Navbar />
        <div className="content-wrapper">
          <AppRoutes/>
        </div>
      </div>
    </Router>
  );

 
  
}

export default App;
